import React from "react";

// import { useNavigate } from "react-router-dom";

import LogoDog from "../../assets/images/logo-dog-register.png";
import LogoNex from "../../assets/images/logo-nex-register.png";
import DogStarHeart from "../../assets/images/logo-dog-mini-heart-p2.png";
import LogoSpectra from "../../assets/images/logo-spectra-register-p2.png";
import SuccessStyle from "../../assets/images/success-style.png";
import PrimaryButton from "../../components/button/PrimaryButton";
import PopupRegisterSuccess from "../../components/popup/PopupRegisterSuccess";
import { useLocation, useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/button/SecondaryButton";
import { useSelector } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";

export default function ConfirmSuccess() {
  const store = useSelector((state) => state.registerPetShop);

  const { state } = useLocation();
  const navigate = useNavigate();
  return (
    <>
      <TopLogo />
      <div
        style={{
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          background: "linear-gradient(113.34deg, #213468 16.83%, #213468 39.8%, #1A4984 57.27%, #0D73BB 85.75%, #1B8DCD 97.7%, #2BACE2 108.73%)"

        }}
      >
        <img
          src={SuccessStyle}
          alt="logo"
          style={{ width: "70%", float: "right" }}
          className="mt-[-20px] mr-[-20px]"
        />
        <div className="mt-[40px] w-full" style={{
          position: "fixed",
          left: "50%",
          transform: "translate(-50%, 0)"
        }}>
          <div className="text-white text-center text-[36px] mt-[40px]">
            ยืนยันตัวตนสำเร็จ
          </div>
          <div className="text-white text-center text-[24px]">
          ยินดีต้อนรับสู่ครอบครัว One And Done
          </div>
          <img
            className="mx-auto my-[20px]"
            src={DogStarHeart}
            alt="logo"
            style={{ width: "50%" }}
          />
          <div className="text-white text-center text-[24px]">
            สิทธิพิเศษมากมายจาก{" "}
            <img
              src={LogoSpectra}
              alt="logo"
              style={{ width: "70px", display: "inline-block" }}
            />{" "}
            รอคุณอยู่
          </div>
          <div className="text-center mt-[50px]">
            {/*btn member*/}
            {!store["isPetShop"] && (
              <div className="my-4">
                <PrimaryButton
                  variant="contained"
                  className="w-[70%] !bg-[#082e683d]"
                  onClick={() => {
                    navigate("/dogbook");
                  }}
                  sx={{
                    border: "1px solid white",
                  }}
                >
                  ไปหน้าสมุดพกสัตว์เลี้ยง
                </PrimaryButton>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}
